<template>
  <div>
    <list :list='articlesListData' :pl='false' :link='"/groupofindustries/"+$route.params.catid+"/groupofindustriesdetails/"'></list>
    <!-- 分页 -->
    <div class="padding-tb-xl text-center" v-if="$route.name==='groupofindustriesList' && articlesListData&&articlesListData.count > 0">
      <el-pagination
        background
        :small='isMobile'
        layout="prev, pager, next"
        :total="articlesListData&&articlesListData.count"
        :page-size="params.limit"
        :current-page="params.page"
        @current-change="handlePageChange"
        >、
      </el-pagination>
    </div>
  </div>
</template>

<script>
import list from '../../components/groupofindustries/groupofindustriesList'
import {selectList} from '../../api/article/selectList'
export default {
  data() {
    return {
      isMobile: (window.innerWidth || document.documentElement.clientWidth) < 768 ,
      articlesListData: null, 
      params: {
        page: 1,
        limit: 5,
        key: undefined,
        catId: this.$route.params.catid,
        catType: 2,
        isLock: 0,  //0正常 1锁定
      },
    }
  },
  components: {list},
  created() {
    this.getArticlesList()
  },
  methods: {
    // 获取文章列表
    getArticlesList() {
      this.params.catId = this.$route.params.catid;
      this.params.key = this.$store.state.newsKey;

      selectList(this.params).then(res => {
        this.articlesListData = res;
      }).catch((err) => {
        this.$message.error(err.message);
      })
    },
    // 分页点击
    handlePageChange(val) {
        this.$set(this.params, 'page', val);
        this.getArticlesList();
    },
  },
  destroyed() {
    // 销毁vuex的关键字
    this.$store.commit('setNewsKey','')

  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/register.scss';
@import '../../assets/css/base.scss';
        // 当前分页样式
  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: $basecolor;
  }
  /deep/.el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: rgb(255, 195, 195);
  }
</style>